<app-alert></app-alert>

<div class="dashboard dashboard-center despacho-actual-page">
  <div class="d-flex align-items-center flex-nowrap despacho-actual-toolbar">
    <div class="flex-shrink-0">
      <a (click)="updateUrl()" class="btn btn-primary button-actualizar">
        <i class="bi bi-arrow-clockwise me-2"></i>
        Actualizar
      </a>
    </div>
  </div>

  <app-hormigon-envios-pendientes-list></app-hormigon-envios-pendientes-list>

  <div class="d-flex flex-wrap justify-content-around" *ngIf="currentOrder; else noCurrentDispatch">
    <app-hormigon-dispatch-card
      [order]="currentOrder"
      title="Despacho N°"
      [titleNumber]="currentOrder.orderNumber"
      [showAdditiveRemarks]="false"
      [showPreviousTruck]="false"
      [showOrderNumber]="false"
      (continue)="onContinue($event)"
      (paperGuide)="onPaperGuide($event)">
    </app-hormigon-dispatch-card>
  </div>

  <ng-template #noCurrentDispatch>
    <div *ngIf="dispatchResolved" class="sin-despacho-card">
      <div class="sin-despacho-content">
        <img
          class="sin-despacho-icon"
          src="assets/images/icons/sin_despacho_asignado.svg"
          alt=""
          width="119"
          height="119" />
        <h2 class="sin-despacho-title">No tienes despacho asignado</h2>
        <p class="sin-despacho-text">
          En este momento no hay viajes ni guías asociadas a tu cuenta. Si crees que esto es un error, intenta
          actualizar o contacta a soporte.
        </p>
      </div>
      <button type="button" class="btn btn-primary sin-despacho-button" (click)="updateUrl()">
        Actualizar estado
      </button>
    </div>
  </ng-template>
</div>
